import { BaseRequest } from '../../data/shared/base.request';
import {
  AddEditJobRequest,
  BatchInjectLocationInJobRequest,
  CalculateJobETARequest,
  EditJobRequest,
  GetJobsGridDataRequest,
  InjectLocationInJobRequest,
  Job,
  JobDetails,
  JobFilters,
  JobTemplate,
  LocationsToAddInJobs,
  OptimizeJobRequest,
  ValidateJobTerminalsAndLocationRequest,
  ValidateNewJobTerminalsAndLocationRequest,
} from '../domain';
import { Observable } from 'rxjs';
import { BaseGridResponse } from '../../data/shared/base-grid.response';
import { HttpResponse } from '@angular/common/http';
import { DeleteJobRequest } from '../domain/requests/jobs/delete-jobs-request';
import { CalculatePlanJobETARequest } from '../domain/requests/jobs/calaculate-plan-job-eta-request';
import { GetHDSequenceRequest } from '../domain/requests/jobs/get-hd-sequence-request';
import { UpdateHdJobRequest } from '../domain/requests/jobs/update-hd-job-request';

export abstract class JobsRepository {
  abstract getJobs(
    request: BaseRequest<GetJobsGridDataRequest>
  ): Observable<BaseGridResponse<Job>>;

  abstract getPlanJobs(request: string): Observable<Job[]>;

  abstract getHDPlanJobs(request: string): Observable<Job[]>;

  abstract getJobFilters(request: string): Observable<JobFilters>;

  abstract getLocationsToAddInJob(
    request: string
  ): Observable<LocationsToAddInJobs[]>;

  abstract addJob(request: AddEditJobRequest): Observable<boolean>;

  abstract printJob(request: string): Observable<HttpResponse<Blob>>;

  abstract updateJob(request: EditJobRequest): Observable<boolean>;

  abstract updateHdJob(request: UpdateHdJobRequest): Observable<boolean>;

  abstract deleteJob(request: DeleteJobRequest): Observable<boolean>;

  abstract getJobDetails(request: BaseRequest<string>): Observable<JobDetails>;

  abstract optimizeJob(request: OptimizeJobRequest): Observable<boolean>;

  abstract calculateJobETA(
    request: CalculateJobETARequest
  ): Observable<boolean>;

  abstract injectLocationInJobs(
    request: InjectLocationInJobRequest
  ): Observable<boolean>;

  abstract batchInjectLocationInJobs(
    request: BatchInjectLocationInJobRequest
  ): Observable<boolean>;

  abstract getJobTemplateLookUp(): Observable<JobTemplate[]>;

  abstract JobTerminalsAndLocationsCheck(
    request: ValidateJobTerminalsAndLocationRequest
  ): Observable<boolean>;

  abstract NewJobTerminalsAndLocationsCheck(
    request: ValidateNewJobTerminalsAndLocationRequest
  ): Observable<boolean>;
  
  abstract CalculateHDPlanJobETA(
      request: CalculatePlanJobETARequest
    ): Observable<boolean>;

  abstract GetHDSequence(
      request: GetHDSequenceRequest
    ): Observable<boolean>;
}
